// extracted by mini-css-extract-plugin
export default {"inputWrapper":"InputColorPicker_inputWrapper__y-q3s","input":"InputColorPicker_input__OVCvt","isDisabled":"InputColorPicker_isDisabled__K25V-"};